export default {
  FIRST_AMERICAN: 'FA',
  STRIPE: 'STRIPE',
}
